export default __webpack_public_path__ + "static/media/room2-BASE.27053c75.png";